import React from 'react';
import { Reveal } from '../Reveal';
import { SiblingChoiceGrid } from '../SiblingChoiceGrid';
import type { SiblingRole } from '../../types/snak';
interface OpeningScreenProps {
  selected: SiblingRole | null;
  onSelect: (role: SiblingRole) => void;
}
export function OpeningScreen({
  selected,
  onSelect
}: OpeningScreenProps) {
  return <div className="flex flex-1 flex-col justify-center py-4" data-id="element-145" data-mp="3aezukfh0blvd">
      <Reveal data-id="element-146" data-mp="2mo487xvblivi">
        <p className="font-body text-[13px] leading-relaxed text-[rgba(1,51,43,0.55)]" data-id="element-147" data-mp="2mpxcj6ignr0c">
          Before you meet the Filtek’s...
        </p>
      </Reveal>
      <Reveal delay={0.08} data-id="element-148" data-mp="2wep3pcfp67a7">
        <h1 className="mt-1 font-heading text-[42px] leading-[0.95] tracking-[-0.02em] text-background" data-id="element-149" data-mp="2weys4vl3g6ds">
          What are you?
        </h1>
      </Reveal>
      <Reveal delay={0.16} data-id="element-150" data-mp="2rm5q4fh0fc5e">
        <p className="mt-3 font-body text-[13px] text-[rgba(1,51,43,0.5)]" data-id="element-151" data-mp="23xutxpm9e0ng">
          Pick your place in the family.
        </p>
      </Reveal>

      <div className="mt-6" data-id="element-152" data-mp="1yyrxuuo9b4rm">
        <SiblingChoiceGrid selected={selected} onSelect={onSelect} data-id="element-153" data-mp="1yxgu2uut9x0i" />
      </div>
    </div>;
}